module.exports = __webpack_public_path__ + "img/B高通锐化50.17dd91ed.png";